var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('report-summary',{attrs:{"cells":_vm.summary}}),_c('report-table',{attrs:{"headers":_vm.reportHeaders,"items":_vm.items,"initialSortedColumns":['expirationDate']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }